import type { RichTextCustomLeaf } from '../../../types.js'

export const code: RichTextCustomLeaf = {
  name: 'code',
  Button: '@payloadcms/richtext-slate/client#CodeLeafButton',
  Leaf: '@payloadcms/richtext-slate/client#CodeLeaf',
}
